import { render, staticRenderFns } from "./ProgramProcessScroll.vue?vue&type=template&id=70e6b1b8&scoped=true&"
import script from "./ProgramProcessScroll.vue?vue&type=script&lang=js&"
export * from "./ProgramProcessScroll.vue?vue&type=script&lang=js&"
import style0 from "./ProgramProcessScroll.vue?vue&type=style&index=0&id=70e6b1b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6b1b8",
  null
  
)

export default component.exports